module.exports = __webpack_public_path__ + "media/categories/4017-44406aed.svg";